{
  "Login": "Login",
  "Email": "Email",
  "Password": "Password",
  "ForgotPassword": "Forgot your password?",
  "NoAccount": "Don't have an account?",
  "Signup": "Signup",

  "EmptyFeildMessage": "Hm... looks like we skipped a mandatory field.",
  "IncorrectEmailOrPassword": "Incorrect email or password.",
  "UnableToAcceptInvitation": "You will not be able to accept the invitation using this email address.",

  "EnterValidEmail": "Please enter a valid email.",
  "PasswordMinLength": "Password must be at least 6 characters long",
  "WelcomeBack": "Welcome back",
  "ServerError": "Oops. Something went wrong."
}
